"use client";

import React from "react";
import { SeoHelmet } from "../components/SeoHelmet";
import "./AboutPage.css";
import "./AboutPageStyle.css";

const QR_ROSTOV = "https://max.ru/u/f9LHodD0cOJwdTWxPGV-7S_yLxZ5ey64qaW8vhZHZfxAEQINeUce8o6Q49w";
const QR_ULYANOVSK = "https://max.ru/u/f9LHodD0cOL4ZIczKvd8gcW3t1ztMUcj0zOLAtvjknr23IVEywYej40RqT8";
const QR_SIZE = 126;







const AboutPage: React.FC = () => {


  return (
    <>
      <SeoHelmet
        title="О компании"
        description="ТЕКС МОЛЛ: ткани, в которых технологичность служит комфорту и красоте. Качество, производство, контакты в Ростове-на-Дону и Ульяновске."
        path="/about"
      />
    <div className="aboutPage">
      <div className="aboutPageLeftPart reveal">
        <h2>НАША ПРОДУКЦИЯ - ЭТО ТКАНИ, В КОТОРЫХ ТЕХНОЛОГИЧНОСТЬ СЛУЖИТ КОМФОРТУ И КРАСОТЕ.</h2>
        <p>Благодаря последним разработкам, наши ткани обеспечивают максимальное удобство и позволяют Вам наслаждаться жизнью в гармоничном и уютном пространстве.</p>
        <h2 id="coloredH2">ГОТОВЫ НАЧАТЬ РАБОТУ С НАМИ?</h2>
        <p>Оставьте заявку прямо сейчас!</p>
        <div className="aboutPageLeftPartButtonsContainer">
          <div className="about-buttons-qr-wrapper">
            <a id="coloredBtn" href="/contact" className="btn btn-outline">
              Связаться с нами
            </a>
            <a href="/catalog" className="btn btn-outline">
              Посмотреть каталог
            </a>
            <div className="about-qr-codes">
            <div className="about-qr-block">
              <span className="about-qr-label">Ростов-на-Дону</span>
              <a href={QR_ROSTOV} target="_blank" rel="noopener noreferrer" className="qr-item">
                <img src={`${process.env.PUBLIC_URL || ""}/images/qr-rostov.png`} alt="QR-код Ростов-на-Дону" width={QR_SIZE} height={QR_SIZE} />
              </a>
            </div>
            <div className="about-qr-block">
              <span className="about-qr-label">Ульяновск</span>
              <a href={QR_ULYANOVSK} target="_blank" rel="noopener noreferrer" className="qr-item">
                <img src={`${process.env.PUBLIC_URL || ""}/images/qr-ulyanovsk.png`} alt="QR-код Ульяновск" width={QR_SIZE} height={QR_SIZE} />
              </a>
            </div>
          </div>
          </div>
        </div>
      </div>
      <div className="aboutPageRightPart reveal-stagger">
        
          <div className="advantage reveal-child">
            <h2>Проверенные материалы</h2>
            <p>Только лучшие ткани от надежных поставщиков</p>
          </div>
          <div className="advantage reveal-child">
            <h2>Контроль качества</h2>
            <p>Каждая партия проходит строгий контроль</p>
          </div>
        

       
          <div className="advantage reveal-child">
            <h2>Современное производство</h2>
            <p>Используем передовые технологии</p>
          </div>
          <div className="advantage reveal-child">
            <h2>Актуальный дизайн</h2>
            <p>Следим за интерьерными трендами </p>
          </div>
        
      </div>
    </div>
    </>
  );
};

export default AboutPage;
